module.exports = __webpack_public_path__ + "img/cxTrends-5.680a6930.png";